import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _MEDICINE_CATEGORY, _PRODUCT_CATEGORIES;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as R from 'ramda';
import { MedicineCategory, ProductsCategories } from 'src/types';
var FREQUENCY_RATIO_MAPPING = {
  BIDMC: {
    key: 'BIDMC',
    ratio: 2.0,
    day: 1,
    count: 2,
    text: '每日二次，隨餐(跟飯一起吃)'
  },
  BIDPC: {
    key: 'BIDPC',
    ratio: 2.0,
    day: 1,
    count: 2,
    text: '每日二次，飯後(一個小時以內)'
  },
  HS: {
    key: 'HS',
    ratio: 1.0,
    day: 1,
    count: 1,
    text: '每日一次，睡前'
  },
  QDAC: {
    key: 'QDAC',
    ratio: 1.0,
    day: 1,
    count: 1,
    text: '每日一次，早上飯前三十分鐘'
  },
  QDMC: {
    key: 'QDMC',
    ratio: 1.0,
    day: 1,
    count: 1,
    text: '每日一次，隨餐(跟飯一起吃)'
  },
  QDPC: {
    key: 'QDPC',
    ratio: 1.0,
    day: 1,
    count: 1,
    text: '每日一次，飯後(一個小時以內)'
  },
  QN: {
    key: 'QN',
    ratio: 1.0,
    day: 1,
    count: 1,
    text: '每晚一次'
  },
  QODAC: {
    key: 'QODAC',
    ratio: 0.5,
    day: 2,
    count: 1,
    text: '每二日一次，早上飯前三十分鐘'
  },
  TIDAC: {
    key: 'TIDAC',
    ratio: 3.0,
    day: 1,
    count: 3,
    text: '每日三次，飯前(一小時)'
  },
  TIDMC: {
    key: 'TIDMC',
    ratio: 3.0,
    day: 1,
    count: 3,
    text: '每日三次，隨餐(跟飯一起吃)'
  },
  TIDPC: {
    key: 'TIDPC',
    ratio: 3.0,
    day: 1,
    count: 3,
    text: '每日三次，飯後(一個小時以內)'
  },
  QIW1357: {
    key: 'QIW1357',
    ratio: 0.571,
    day: 7,
    count: 4,
    text: '每週四次，週一、週三、週五、週日'
  },
  QNM: {
    key: 'QNM',
    ratio: 1.0,
    day: 1,
    count: 1,
    text: '每日晚餐隨餐'
  },
  QNOONM: {
    key: 'QNOONM',
    ratio: 1.0,
    day: 1,
    count: 1,
    text: '每日午餐隨餐'
  },
  BID: {
    key: 'BID',
    ratio: 2.0,
    day: 1,
    count: 2,
    text: '每日二次'
  },
  BIDAC: {
    key: 'BIDAC',
    ratio: 2.0,
    day: 1,
    count: 2,
    text: '每日二次，飯前(一小時)'
  },
  BIW14: {
    key: 'BIW14',
    ratio: 0.286,
    day: 7,
    count: 2,
    text: '每週二次，週一、週四'
  },
  BIW25: {
    key: 'BIW25',
    ratio: 0.286,
    day: 7,
    count: 2,
    text: '每週二次，週二、週五'
  },
  BIW36: {
    key: 'BIW36',
    ratio: 0.286,
    day: 7,
    count: 2,
    text: '每週兩次，週三、週六'
  },
  PRN: {
    key: 'PRN',
    ratio: 1.0,
    day: 1,
    count: 1,
    text: '需要時使用'
  },
  Q2W: {
    key: 'Q2W',
    ratio: 0.071,
    day: 14,
    count: 1,
    text: '每二週一次'
  },
  QD: {
    key: 'QD',
    ratio: 1.0,
    day: 1,
    count: 1,
    text: '每日一次'
  },
  QID: {
    key: 'QID',
    ratio: 4.0,
    day: 1,
    count: 4,
    text: '每日四次'
  },
  QM: {
    key: 'QM',
    ratio: 0.033,
    day: 30,
    count: 1,
    text: '每月一次'
  },
  QOD: {
    key: 'QOD',
    ratio: 0.5,
    day: 2,
    count: 1,
    text: '每二日一次'
  },
  QOW: {
    key: 'QOW',
    ratio: 0.071,
    day: 14,
    count: 1,
    text: '每二週一次'
  },
  QW: {
    key: 'QW',
    ratio: 0.142,
    day: 7,
    count: 1,
    text: '每週一次'
  },
  ST: {
    key: 'ST',
    ratio: 1.0,
    day: 1,
    count: 1,
    text: '立即使用'
  },
  TID: {
    key: 'TID',
    ratio: 3.0,
    day: 1,
    count: 3,
    text: '每日三次'
  },
  TIW135: {
    key: 'TIW135',
    ratio: 0.429,
    day: 7,
    count: 3,
    text: '每週三次，週一、週三、週五'
  },
  TIW246: {
    key: 'TIW246',
    ratio: 0.429,
    day: 7,
    count: 3,
    text: '每週三次，週二、週四、週六'
  }
};
var frequency_ratio = R.mapObjIndexed(function (item) {
  return item.ratio;
}, FREQUENCY_RATIO_MAPPING);
var frequency_option = R.pipe(R.values, R.map(function (item) {
  return {
    label: item.key,
    value: item.key
  };
}))(FREQUENCY_RATIO_MAPPING);
var medicine_status = {
  active: 'active',
  inactive: 'inactive'
};
var MEDICINE_CATEGORY = (_MEDICINE_CATEGORY = {}, _defineProperty(_MEDICINE_CATEGORY, MedicineCategory.neutrional_supplement, {
  value: 0,
  priority: 1,
  key: MedicineCategory.neutrional_supplement,
  i18n: 'common:productsCategories.neutrional_supplement',
  text: '保健品'
}), _defineProperty(_MEDICINE_CATEGORY, MedicineCategory.food_supplement, {
  value: 1,
  priority: 2,
  key: MedicineCategory.food_supplement,
  i18n: 'common:productsCategories.food_supplement',
  text: '食品'
}), _defineProperty(_MEDICINE_CATEGORY, MedicineCategory.drug, {
  value: 2,
  priority: 0,
  key: MedicineCategory.drug,
  i18n: 'common:productsCategories.drug',
  text: '藥物'
}), _defineProperty(_MEDICINE_CATEGORY, MedicineCategory.medical_device, {
  value: 3,
  priority: 3,
  key: MedicineCategory.medical_device,
  i18n: 'common:productsCategories.medical_device',
  text: '設備器材'
}), _MEDICINE_CATEGORY);
var PRODUCT_CATEGORIES = (_PRODUCT_CATEGORIES = {}, _defineProperty(_PRODUCT_CATEGORIES, ProductsCategories.drug, {
  key: ProductsCategories.neutrional_supplement,
  i18n: 'common:productsCategories.neutrional_supplement',
  text: '保健品'
}), _defineProperty(_PRODUCT_CATEGORIES, ProductsCategories.food_supplement, {
  key: ProductsCategories.food_supplement,
  i18n: 'common:productsCategories.food_supplement',
  text: '食品'
}), _defineProperty(_PRODUCT_CATEGORIES, ProductsCategories.neutrional_supplement, {
  key: ProductsCategories.neutrional_supplement,
  i18n: 'common:productsCategories.neutrional_supplement',
  text: '藥物'
}), _defineProperty(_PRODUCT_CATEGORIES, ProductsCategories.medical_device, {
  key: ProductsCategories.medical_device,
  i18n: 'common:productsCategories.medical_device',
  text: '設備器材'
}), _defineProperty(_PRODUCT_CATEGORIES, ProductsCategories.medical_care_examination, {
  key: ProductsCategories.medical_care_examination,
  i18n: 'common:productsCategories.medical_care_examination',
  text: '醫療檢查'
}), _defineProperty(_PRODUCT_CATEGORIES, ProductsCategories.medical_care_outpatient_service, {
  key: ProductsCategories.medical_care_outpatient_service,
  i18n: 'common:productsCategories.medical_care_outpatient_service',
  text: '門診服務'
}), _defineProperty(_PRODUCT_CATEGORIES, ProductsCategories.medical_care_therapy, {
  key: ProductsCategories.medical_care_therapy,
  i18n: 'common:productsCategories.medical_care_therapy',
  text: '治療/點滴'
}), _defineProperty(_PRODUCT_CATEGORIES, ProductsCategories.medical_care_wellness_program, {
  key: ProductsCategories.medical_care_wellness_program,
  i18n: 'common:productsCategories.medical_care_wellness_program',
  text: '健康管理'
}), _defineProperty(_PRODUCT_CATEGORIES, ProductsCategories.medical_care_treatment, {
  key: ProductsCategories.medical_care_treatment,
  i18n: 'common:productsCategories.medical_care_treatment',
  text: '醫療服務'
}), _PRODUCT_CATEGORIES);
var MAP_MEDICINE_CATEGORY_FROM_VALUE = R.pipe(R.values, R.reduce(function (acc, cur) {
  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cur.value, cur));
}, {}))(MEDICINE_CATEGORY);
var SingleAmountAdditionalValues = [0.33, 0.6, 0.75, 1.2, 1.5, 1.8, 2.4, 2.5, 150, 200, 300];
var MaxMedicineAmount = 1000;
var CATEGORY_ORDER = ['藥物', '保健品', '食品', '設備', '門診', '線上課程', '檢測', '治療/點滴'];
var CATEGORY_ORDER_MAP = Object.fromEntries(CATEGORY_ORDER.map(function (category, index) {
  return [category, index];
})); // Product property mapping to CSV column index

var PRODUCT_PROP_CSV_INDEX_MAP = {
  enabled: 0,
  serial_code: 1,
  chinese_name: 7,
  english_name: 6,
  usage: 4,
  manufacturer: 5,
  category: 2,
  accounting_category: 3,
  minimum_unit: 8,
  package_unit: 9,
  package_amount: 10,
  single_amount: 11,
  frequency: 12,
  days: 13,
  basic_compliance: 14,
  safe_stock_amount: 21,
  side_effect: 15,
  indications: 16,
  list_price: 17,
  price: 18
};
var constants = {
  frequency_ratio: frequency_ratio,
  frequency_option: frequency_option,
  medicine_status: medicine_status,
  MEDICINE_CATEGORY: MEDICINE_CATEGORY,
  PRODUCT_CATEGORIES: PRODUCT_CATEGORIES,
  SingleAmountAdditionalValues: SingleAmountAdditionalValues,
  MaxMedicineAmount: MaxMedicineAmount,
  FREQUENCY_RATIO_MAPPING: FREQUENCY_RATIO_MAPPING,
  MAP_MEDICINE_CATEGORY_FROM_VALUE: MAP_MEDICINE_CATEGORY_FROM_VALUE,
  CATEGORY_ORDER: CATEGORY_ORDER,
  CATEGORY_ORDER_MAP: CATEGORY_ORDER_MAP,
  PRODUCT_PROP_CSV_INDEX_MAP: PRODUCT_PROP_CSV_INDEX_MAP
};
export default constants;